"use strict";

var LoggerInstance = require("js-logger").get("ShipToStore");

var AbstractStore = require("./AbstractStore");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var state = {
	isDesignMode: false,
	prevSelectorValue: null
};

var ShipToStore = class extends AbstractStore {
	getState() {
		return state;
	}

	get(key) {
		return state[key];
	}
};

ShipToStore.dispatchToken = Dispatcher.register(function (action) {
	switch (action.actionType) {
		case Constants.SHIPTO_INITIALIZE:
			state.isDesignMode = action.isDesignMode;
			return true; // Don't emit change

		case Constants.SHIPTO_SET_SELECTOR:
			state.prevSelectorValue = action.selectorValue;
			return true; // Don't emit change

		default:
			// no op
			return true;
	}

	ShipToStore.emitChange();
	return true;
});

module.exports = new ShipToStore();
